import { render, staticRenderFns } from "./Bargainshare.vue?vue&type=template&id=013ff84b&scoped=true&"
import script from "./Bargainshare.vue?vue&type=script&lang=js&"
export * from "./Bargainshare.vue?vue&type=script&lang=js&"
import style0 from "./Bargainshare.vue?vue&type=style&index=0&id=013ff84b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ff84b",
  null
  
)

export default component.exports